// contexts/AnalysisContext.js

import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import {urls } from "../services/apiService"

const AnalysisContext = createContext();

export const AnalysisProvider = ({ children }) => {
  const [analysisUrl, setAnalysisUrl] = useState("");
  const [analysisType, setAnalysisType] = useState("NDVI"); // Default analysis type
  const [polygon, setPolygon] = useState(null); // This will store the current polygon data
  const [msaviResults, setMsaviResults] = useState([]);
  const [ndviResults, setNdviResults] = useState([]);
  const [ndreResults, setNdreResults] = useState([]);
  const [ndmiResults, setNdmiResults] = useState([]);
  const [allMSAVIvalidJsonArrays, setAllMSAVIvalidJsonArrays] = useState([]);
  const [allNDREvalidJsonArrays, setAllNDREvalidJsonArrays] = useState([]);
  const [allNDVIvalidJsonArrays, setAllNDVIvalidJsonArrays] = useState([]);
  const [allNDMIvalidJsonArrays, setAllNDMIvalidJsonArrays] = useState([]);
  const [data, setData] = useState(null);
  const [flag, setFlag] = useState(false);
  const [showDates, setShowDates] = useState(false);

  const [loginTime,setLoginTime] = useState('')
  const [changePassTime,setChangePassTime] = useState('')
  const [addFieldTime,setaddFieldTime] = useState('')
  const [analysisTime,setAnalysisTime] = useState('')
  const [nccResults, setNccResults] = useState([]);



  useEffect(() => {
    // Load data from local storage
    const storedLoginTime = localStorage.getItem('loginTime');
    const storedChangePassTime = localStorage.getItem('changePassTime');
    const storedAddFieldTime = localStorage.getItem('addFieldTime');
    const storedAnalysisTime = localStorage.getItem('analysisTime');
    
    if (storedLoginTime) setLoginTime(storedLoginTime);
    if (storedChangePassTime) setChangePassTime(storedChangePassTime);
    if (storedAddFieldTime) setaddFieldTime(storedAddFieldTime);
    if (storedAnalysisTime) setAnalysisTime(storedAnalysisTime);
  }, []);

  useEffect(() => {
    // Save data to local storage whenever it changes
    localStorage.setItem('loginTime', loginTime);
    localStorage.setItem('changePassTime', changePassTime);
    localStorage.setItem('addFieldTime', addFieldTime);
    localStorage.setItem('analysisTime', analysisTime);
  }, [loginTime, changePassTime, addFieldTime, analysisTime]);

  const [toastMsg, setToastMsg] = useState({
    isShown: false,
    message: "",
    type: "success", // can be 'success', 'error', etc.
  });

  const handleCloseToast = () => {
    setToastMsg({
      isShown: false,
      message: "",
    });
  };


  const fetchAnalysisUrl = useCallback((polygonData, type) => {

    const apiUrl = urls.api_analyze_polygon;
    const dataToSend = {
      geojson: polygonData,
      analysisType: type,
    };

    fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(dataToSend),
    })
    .then(async(response) => {
      if (!response.ok) {
        return response.text().then(text => {
          throw new Error(`HTTP error! status: ${response.status}, ${text}`);
        });
      }
      return await response.json();
    })
    .then(data => {
      setAnalysisUrl(data.url);
    })
    .catch(error => {
      console.error('Fetching analysis URL failed:', error);
    });
  }, [setAnalysisUrl]);
  // start main api call
 

 
    const fetchIndicesValues = async (fieldname) => {
      try {
        const response = await fetch(urls.indices_value, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ fieldname }), // Sending the fieldname in the POST request body
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        const msavi = data['msavi_values'];
        const ndre = data['ndre_values'];
        const ndvi = data['ndvi_values'];
        const ndmi = data['ndmi_values'];

        // Parse JSON strings into arrays
        const msaviArrays = msavi.map((item) => JSON.parse(item.replace(/'/g, '"')));
        const ndreArrays = ndre.map((item) => JSON.parse(item.replace(/'/g, '"')));
        const ndviArrays = ndvi.map((item) => JSON.parse(item.replace(/'/g, '"')));
        const ndmiArrays = ndmi.map((item) => JSON.parse(item.replace(/'/g, '"')));

        // Update state with parsed arrays
        setAllMSAVIvalidJsonArrays(msaviArrays);
        setAllNDREvalidJsonArrays(ndreArrays);
        setAllNDVIvalidJsonArrays(ndviArrays);
        setAllNDMIvalidJsonArrays(ndmiArrays);
      } catch (error) {
        console.error('Error fetching indices values:', error);
      }
    };
  // Function to reset/clear all analysis data
  const clearData = () => {
    setMsaviResults([]);
    setNdviResults([]);
    setNdreResults([]);
    setNdmiResults([]);
    setAllMSAVIvalidJsonArrays([]);
    setAllNDREvalidJsonArrays([]);
    setAllNDVIvalidJsonArrays([]);
    setAllNDMIvalidJsonArrays([]);
    setData(null);
    setFlag(false)
    setAnalysisUrl("");  // Reset analysis URL if needed
    setAnalysisType("NDVI");  // Reset to default analysis type
  };

  const fetchResults = (field, value) => {
    const resultsApiUrl = urls.get_results;
    const dataToSend = {
      indexType: value, // Set the appropriate indexType
      fieldName: field, // Set the appropriate fieldName
    };
    fetch(resultsApiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dataToSend),
    })
      .then(async (response) => {
        if (response.ok) {
          // console.log("data to send", dataToSend);
        }
        let data = response.json();
        setData(data);

 
        data.then((data) => {
          if (response.ok) {
            setFlag(true);
  
            // Initialize arrays for each index
            const msavi = [];
            const ndvi = [];
            const ndre = [];
            const ndmi = [];
            const ncc = []; // New array for NCC
          
            data.results.forEach((result) => {
              const { IndexType, Date, Url } = result;
              const formattedResult = { Date, Url };
  
              // Handle each IndexType, including NCC
              switch (IndexType) {
                case 'MSAVI':
                  msavi.push(formattedResult);
                  break;
                case 'NDVI':
                  ndvi.push(formattedResult);
                  break;
                case 'NDRE':
                  ndre.push(formattedResult);
                  break;
                case 'NDMI':
                  ndmi.push(formattedResult);
                  break;
                case 'NCC': // Handle NCC
                  ncc.push(formattedResult);
                  break;
                default:
                  break;
              }
            });
  
            // Set the results for each index
            setMsaviResults(msavi);
            setNdviResults(ndvi);
            setNdreResults(ndre);
            setNdmiResults(ndmi);
            setNccResults(ncc); // Set the NCC results
          }
        });
      })
      .catch((error) => {
        console.error('Fetching results failed:', error);
      });
  };
  


  const runNewAnalysis = useCallback(() => {
    setMsaviResults([]);
    setNdviResults([]);
    setNdreResults([]);
    setNdmiResults([]);
    setFlag(false);
  }, []);

  return (
    <AnalysisContext.Provider
      value={{
        analysisUrl,
        setAnalysisUrl,
        analysisType,
        setAnalysisType,
        fetchAnalysisUrl,
        fetchResults,
        polygon,
        setPolygon,
        ndmiResults,
        ndreResults,
        ndviResults,
        msaviResults,
        flag,
        nccResults, 
        setNccResults,
        runNewAnalysis,
        fetchIndicesValues,
        allMSAVIvalidJsonArrays,
        allNDREvalidJsonArrays,
        allNDVIvalidJsonArrays,
        allNDMIvalidJsonArrays,
        data,
        // Toast message state and handlers
        toastMsg,
        setToastMsg,

        handleCloseToast,
        // time state
        loginTime,
        setLoginTime,
        changePassTime,
        setChangePassTime,
        addFieldTime,
        setaddFieldTime,
        analysisTime,
        setAnalysisTime,        

        handleCloseToast,
        showDates,
        setShowDates,
        clearData
     
      }}
    >
      {children}
    </AnalysisContext.Provider>
  );
};

export const useAnalysis = () => useContext(AnalysisContext);